<template>
    <div class="newsList">
        <!-- <div class="datanull" v-show="!nullDisplaySon&&(!listcontent||!listcontent.length)">
            暂无相关数据！
        </div> -->
        <div v-for="(item,index) in listcontent" :key="index" class="boxContent" @click="enterDetails(item)">
            <div class="nophoto" v-if="!item.thumb">
                <div class="newsTitle nophotoTitle">
                    <p class="titleName">{{item.title}}</p>
                    <div class="sorceTime">
                        <span>{{item.source}}</span>
                        <span>{{item.dateline|date}}</span>
                    </div>
                </div>
            </div>
            <div class="oneImg" v-else-if="item.thumb.split(',').length<3&&index%4!=0&&!item.video">
                <div class="newsTitle">
                    <p class="titleName">{{item.title}}</p>
                    <div class="sorceTime">
                        <span>{{item.source}}</span>
                        <span>{{item.dateline|date}}</span>
                    </div>
                </div>
                <div class="newsThumbOne">
                    <img class="newsThumb" :src="item.thumb.split(',')[0]" alt="">
                    <img src="../../assets/vedioSing.png" alt="" class="vedioPlaySign" v-if="item.video">
                </div>
            </div>
            <div class="moreImg moreAndOne" v-else-if="(item.thumb.split(',').length<3&&index%4==0)||item.video">
                <p class="moreAndOneTitle">{{item.title}}</p>
                <div class="newsThumbBox newsThumbBoxOne">
                    <img class="newsThumb" :src="item.thumb.split(',')[0]" alt="">
                    <img src="../../assets/vedioSing.png" alt="" class="vedioPlaySign morevedioPlaySign" v-if="item.video">
                </div>
                <div class="sorceTime">
                    <span>{{item.source}}</span>
                    <span>{{item.dateline|date}}</span>
                </div>
            </div>
            <div v-else class="moreImg">
                <p class="titleName">{{item.title}}</p>
                <div class="newsThumbBox">
                    <div v-for="(imgper,indexs) in item.thumb.split(',').slice(0,3)" :key="indexs">
                        <img class="newsThumb" :src="imgper" alt="">
                    </div>
                </div>
                <div class="sorceTime">
                    <span>{{item.source}}</span>
                    <span>{{item.dateline|date}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
		listcontent: {  //是否显示
			type: Array,
			default:()=>[], //必须是一个函数
			required:false,   
        },
        nullDisplaySon:{ //正在显示的位置
            type: Boolean,
            default:()=>false, //必须是一个函数
            required:false,  //不是必填项                     
        }
    },
    data(){
        return{

        }
    },
    methods:{
        enterDetails(item){
            var link;
            if(item.matrix_judge==1){
                link=window.location.href.split("#/")[0]+"#/details?id="+item.medid_id+'&judge'; //链接
            }else{
                if(item.linkerapp){
                    link=item.linkerapp; //链接
                }else{
                    link=window.location.href.split("#/")[0]+"#/details?id="+item.id; //链接
                }
            }
            // window.location.href=link;
            this.link({url: link,title:item.title,noRefresh:"noRefresh"});
        }
    }
}
</script>

<style  scoped>
    .datanull{
        width: 100%;
        height: 100%;
        color: #999999;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
    }
    .boxContent{
        width: calc(100% - 24px);
        padding: 12px 0px;
        margin: 0px auto;
        box-sizing: border-box;
        border-bottom: 1px solid #eeeeee;
    }
    .oneImg{
        width:100%;
        height:80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .nophoto{
        width: 100%;
        height: 60px;
    }
    .newsThumbBox{
        width: 100%;
        /* height: 80px; */
        display: flex;
        /* display: -webkit-box; */
        justify-content: space-around;
        align-items: center;
    }
    .newsThumbBoxOne{
        height: 185px;
        position: relative;
    }
    .newsThumbBox>div{
        width: 32%;
        height: 100%;
    }
    .newsThumbOne{
        width: 32%;
        height: 100%;
        position: relative;
    }
    .newsThumb{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
    }
    .vedioPlaySign{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 30px;
        height: 30px;
        margin-top: -15px;
        margin-left: -15px;
        object-fit: contain;
        z-index: 999;
    }
    .morevedioPlaySign{
        width: 40px;
        height: 40px;
        margin-top: -20px;
        margin-left: -20px;
    }
    .newsTitle{
        width: 64%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
    }
    .nophotoTitle{
        width: 100%;
    }
    .titleName{
        width: 100%;
        /* height:37px; */
        color: #333;
        font-size: 15px;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .moreAndOneTitle{
        width: 100%;
        /* height:37px; */
        color: #333;
        font-size: 15px;
        overflow : hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .sorceTime{
        width: 100%;
        display: flex;
        justify-content: space-between;
        color: #999999;
        font-size: 12px;
    }

    /* 后期多图 */
    .moreImg{
        width: 100%;
        /* height: 146px; */
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-content: space-between;
    }
    .moreAndOne{
        height: 233px;
    }
</style>